import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const Wrapper = styled.div`
  background: white;
  padding: 2rem 0 1.5rem;
  border-radius: 0.75rem;
  border: 1px solid ${colors.gandalf};
  width: 100%;
  text-align: center;

  button {
    margin: 0 auto;
    display: block;
  }

  p {
    margin-bottom: 1rem;
  }

  @media (max-width: 36.25rem) {
    margin-bottom: 1.5rem;
  }
`
export const Logo = styled.div<{ icon?: string }>`
  background: ${({ icon }) => (icon ? `url(${icon}) no-repeat center` : `${colors.gandalf}`)};
  background-size: 60%;
  border: 1px solid ${colors.gandalf};
  border-radius: 50%;
  height: 6.625rem;
  width: 6.625rem;
  margin: 0 auto 1rem;
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandCard/BrandCard.style.tsx